"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeMetadata = exports.writeSchema = void 0;
const core_api_1 = require("@ikegps/core-api");
const writeFields = (fields) => fields.map((field) => FieldWriter.write(field));
const BaseFieldWriter = {
    write(field) {
        const fieldJSON = {
            name: field.id,
            displayname: field.displayName,
            type: field.type
        };
        if (field.title != null) {
            fieldJSON.title = field.title;
        }
        if (field.subtitle != null) {
            fieldJSON.subtitle = field.subtitle;
        }
        if (field.adminOnly != null) {
            fieldJSON.adminOnly = field.adminOnly;
        }
        if (field.annotationLabelFieldId != null) {
            fieldJSON.annotationLabelFieldId = field.annotationLabelFieldId;
        }
        if (field.clearanceThresholdInMeters != null) {
            fieldJSON.clearanceThresholdInMeters = field.clearanceThresholdInMeters;
        }
        if (field.cloneable != null) {
            fieldJSON.cloneable = field.cloneable;
        }
        if (Array.isArray(field.providers) && field.providers.length > 0) {
            fieldJSON.providers = field.providers;
        }
        if (field.collector != null) {
            fieldJSON.collector = field.collector;
        }
        if (field.required != null) {
            fieldJSON.required = field.required;
        }
        return fieldJSON;
    }
};
const SubFormWriter = {
    TYPE: core_api_1.IkeFieldType.FORM,
    write(field) {
        const fieldJSON = BaseFieldWriter.write(field);
        fieldJSON.schema = {
            fields: writeFields(field.fields),
            label: undefined
        };
        if (Array.isArray(field.label) && field.label.length > 0) {
            fieldJSON.schema.label = field.label;
        }
        return fieldJSON;
    }
};
const NestedListWriter = {
    TYPE: core_api_1.IkeFieldType.NESTED_LIST,
    write(field) {
        const fieldJSON = BaseFieldWriter.write(field);
        fieldJSON.options = this.writeOptions(field.options);
        return fieldJSON;
    },
    writeOptions(options) {
        if (options == null) {
            return null;
        }
        return {
            title: options.title,
            values: options.values.map((value) => {
                const valueJSON = {
                    value: value.value
                };
                if (value.code != null) {
                    valueJSON.code = value.code;
                }
                if (value.color != null) {
                    valueJSON.color = value.color;
                }
                if (value.options != null) {
                    valueJSON.options = this.writeOptions(value.options);
                }
                return valueJSON;
            })
        };
    }
};
const SelectListWriter = {
    TYPE: core_api_1.IkeFieldType.SELECT_LIST,
    write(field) {
        const fieldJSON = BaseFieldWriter.write(field);
        fieldJSON.options = field.options.map(({ text, value, color }) => ({ text, value, color }));
        return fieldJSON;
    }
};
const FieldWriter = {
    writers: {
        [SubFormWriter.TYPE]: SubFormWriter,
        [NestedListWriter.TYPE]: NestedListWriter,
        [SelectListWriter.TYPE]: SelectListWriter,
        DEFAULT: BaseFieldWriter
    },
    getWriter(type) {
        return this.writers[type] || this.writers.DEFAULT;
    },
    write(field) {
        return this.getWriter(field.type).write(field);
    }
};
const writeSchema = (fields) => {
    return {
        fields: writeFields(fields)
    };
};
exports.writeSchema = writeSchema;
const writeMetadata = (metadata, fields) => {
    if (metadata === null || Object.keys(metadata).length === 0) {
        return undefined;
    }
    const metadataJSON = JSON.parse(JSON.stringify(metadata.options));
    const emptyJSON = JSON.parse('{}');
    if (metadata.import && metadata.import.type != null && metadata.import.version != null) {
        metadataJSON.import = {
            type: metadata.import.type,
            version: metadata.import.version
        };
    }
    const statusFieldId = metadata.statusFieldId;
    if (statusFieldId != null) {
        metadataJSON.status = { field: statusFieldId };
    }
    const mapColorFieldId = metadata.mapColorFieldId;
    if (mapColorFieldId != null) {
        metadataJSON.mapColor = { field: mapColorFieldId };
    }
    const addressLookupFieldId = metadata.addressLookupFieldId;
    if (addressLookupFieldId != null) {
        metadataJSON.address_lookup = { address: { field: addressLookupFieldId } };
    }
    else {
        delete metadataJSON.address_lookup;
    }
    if (JSON.stringify(metadataJSON).localeCompare(JSON.stringify(emptyJSON)) === 0) {
        return undefined;
    }
    return metadataJSON;
};
exports.writeMetadata = writeMetadata;
//# sourceMappingURL=db.v1.write.js.map